export default __webpack_public_path__ + "static/media/bin.00ab5253.svg";